<template>
  <div class="animate__animated animate__fadein animate__delay-0.5s animate__slower">
    <img src="../../assets/Personback.png" alt=""
      style="width: .4167rem;height: .1458rem;position: relative; top: -0.2083rem;left: -0.2604rem;"
      @click="$router.go(-1)">
    <div class="ok"></div>
    <h2>　提交成功！</h2>
    <h2>{{ checked[0] }}</h2>
    <h2>{{ checked[1] }}</h2>
    <img :src="'https://www.cdjjwang.com/' + src" alt="" class="ma">
    <h2>扫码添加学管老师微信</h2>
  </div>
</template>

<script>
export default {
  data() {
    return {
      src: '',
      all: {
        0: ['您的资料正在审核中', '请添加客服微信跟进审核进度'],
        1: ['您的资料已进入绿色通道', '请添加客服微信跟进审核进度'],
        2: ['预约提交成功', '稍后会有学管老师来电和您对接'],
        3: ['您的需求将在通过审核后发布', '请添加客服微信跟进审核进度']
      },
      checked: [],
    }
  },
  created() {
    this.checked = this.all[this.$route.hash.slice(1)]
    console.log(this.checked);

  },
  mounted() {
    this.$http.get('/Api/Web/Config/Online', {
      headers: {
        'Authorization': localStorage.getItem('Authorization')
      }
    }).then(res => {
      this.src = res.data.data[0].qrcode
      console.log(this.src);
    })
  }
}
</script>

<style scoped>
.ok {
  background: url('../../assets/PersonSucces.png');
  background-size: 100% 100%;
  width: 80px;
  height: 80px;
  margin: 0 auto;
}

h2 {
  text-align: center;
  /* 您的资料正在审核中 */
  color: rgb(0, 0, 0);
  font-family: 苹方;
  font-size: 25px;
  font-weight: 400;
  line-height: 42px;
  letter-spacing: 0px;
  cursor: default;
}

.ma {
  display: inline-block;
  width: 162px;
  height: 162px;
  margin-left: 50%;
  margin-top: 28px;
  transform: translateX(-50%);
}

.wechat {
  height: 32.07px;
  color: rgb(22, 159, 232);
  font-family: 苹方;
  font-size: 24px;
  font-weight: 400;
  line-height: 34px;
  letter-spacing: 0px;
  text-align: center;
  text-decoration-line: underline;
  margin-top: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/studentsuccess.vue